// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5314187f"};